import { ReactNode } from "react";
import { cn } from "utils/cn";

export function DisembodiedHeader(props: {
  children?: ReactNode;
  className?: string;
  renderRight?: () => ReactNode;
}) {
  return (
    <div
      className={cn(
        "mb-6 flex flex-nowrap items-center gap-5",
        props.className
      )}
    >
      <div className="shrink-0 grow basis-auto text-2xl font-extrabold">
        {props.children}
      </div>
      {props.renderRight && (
        <div className="shrink-0 grow-0 basis-auto">{props.renderRight()}</div>
      )}
    </div>
  );
}
